(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tog-cinematic-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const initialized = new WeakSet();
  function initialize(root) {
    root.querySelectorAll('[data-cinema]').forEach(hero => {
      if (initialized.has(hero)) return;
      initialized.add(hero);
      const video = hero.querySelector('video');
      if (!video) return;
      video.muted = true;
      const play = () => {
        if (reduced.matches || document.hidden) return;
        video.play().catch(() => hero.classList.remove('is-playing'));
      };
      video.addEventListener('playing', () => hero.classList.add('is-playing'));
      video.addEventListener('error', () => hero.classList.remove('is-playing'));
      const preferenceChange = () => {
        if (reduced.matches) {video.pause();hero.classList.remove('is-playing');}
        else play();
      };
      reduced.addEventListener('change', preferenceChange);
      const visibilityChange = () => { if (!document.hidden) play(); };
      document.addEventListener('visibilitychange', visibilityChange);
      const unload = event => {
        if (!event.target.contains(hero)) return;
        video.pause();
        reduced.removeEventListener('change', preferenceChange);
        document.removeEventListener('visibilitychange', visibilityChange);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
      play();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), {once:true});
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tog-cursor-zoom"]) return;
  try {
    
(() => {
  if (window.togCursorZoomInstalled) return;
  window.togCursorZoomInstalled = true;
  const enabled = window.matchMedia('(hover: hover) and (pointer: fine)');
  const selector = '.product__media-wrapper .product__modal-opener--image';
  let active = null;
  let frame = 0;
  let point = null;

  function reset() {
    cancelAnimationFrame(frame);
    frame = 0;
    point = null;
    if (!active) return;
    active.image.classList.remove('tog-hover-zoom-active');
    active.image.style.removeProperty('--tog-zoom-x');
    active.image.style.removeProperty('--tog-zoom-y');
    if (active.sizes === null) active.image.removeAttribute('sizes');
    else active.image.setAttribute('sizes', active.sizes);
    active = null;
  }

  function position() {
    frame = 0;
    if (!active || !point || !active.image.isConnected) return;
    const rect = active.media.getBoundingClientRect();
    if (!rect.width || !rect.height) return;
    const x = Math.max(0, Math.min(100, (point.x - rect.left) / rect.width * 100));
    const y = Math.max(0, Math.min(100, (point.y - rect.top) / rect.height * 100));
    active.image.style.setProperty('--tog-zoom-x', x + '%');
    active.image.style.setProperty('--tog-zoom-y', y + '%');
  }

  function track(event) {
    if (!enabled.matches || event.pointerType === 'touch') return;
    const opener = event.target.closest?.(selector);
    if (!opener) return;
    const media = opener.querySelector('.product__media');
    const image = media?.querySelector('img');
    if (!image) return;
    if (!active || active.image !== image) {
      reset();
      active = { opener, media, image, sizes: image.getAttribute('sizes') };
      image.setAttribute('sizes', Math.ceil(media.getBoundingClientRect().width * 2) + 'px');
      point = { x: event.clientX, y: event.clientY };
      position();
      image.classList.add('tog-hover-zoom-active');
    }
    point = { x: event.clientX, y: event.clientY };
    if (!frame) frame = requestAnimationFrame(position);
  }

  document.addEventListener('pointerover', track, { passive: true });
  document.addEventListener('pointermove', track, { passive: true });
  document.addEventListener('pointerout', (event) => {
    if (active && !active.opener.contains(event.relatedTarget)) reset();
  }, { passive: true });
  document.addEventListener('click', (event) => {
    if (active?.opener.contains(event.target)) reset();
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') reset();
  });
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) reset();
  });
  document.addEventListener('shopify:section:unload', reset);
  window.addEventListener('blur', reset);
  enabled.addEventListener('change', reset);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tog-offer-design"]) return;
  try {
    
(() => {
  if (window.togOfferDesignInstalled) return;
  window.togOfferDesignInstalled = true;
  const choose = (link) => {
    const picker = link.closest('variant-selects');
    if (!picker || link.getAttribute('aria-disabled') === 'true') return;
    const ids = link.dataset.offerOptions.split(',').filter(Boolean);
    const inputs = ids.map(id => picker.querySelector(`.tog-native-options input[data-option-value-id="${id}"]`));
    if (!inputs.length || inputs.some(input => !input)) { location.assign(link.href); return; }
    inputs.forEach(input => { input.checked = true; });
    inputs[inputs.length - 1].dispatchEvent(new Event('change', { bubbles: true }));

  };
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-offer-id]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    choose(link);
  });
  const start = () => {
    Promise.all([customElements.whenDefined('variant-selects'), customElements.whenDefined('product-info')]).then(() => {
      document.documentElement.classList.add('tog-offers-ready');
      const params = new URLSearchParams(location.search);
      if (params.has('variant') || params.has('option_values')) return;
      const recommended = document.querySelector('product-info [data-offer-tier="statement"]:not([aria-disabled="true"])');
      if (recommended && recommended.getAttribute('aria-current') !== 'true') location.replace(recommended.href);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tog-product-story"]) return;
  try {
    
(() => {
  function initialize() {
    const bar = document.querySelector('.tog-return-to-options');
    if (!bar || bar.dataset.initialized) return;
    bar.dataset.initialized = 'true';
    let frame = 0;
    function update() {
      frame = 0;
      const purchase = document.querySelector('product-info .product-form__submit');
      bar.hidden = !purchase || purchase.getBoundingClientRect().bottom >= 0;
    }
    function schedule() { if (!frame) frame = requestAnimationFrame(update); }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    document.addEventListener('change', schedule);
    update();
    bar.querySelector('button').addEventListener('click', () => {
      const target = document.querySelector('product-info variant-selects') || document.querySelector('product-info .product-form__submit');
      if (!target) return;
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
      const focusTarget = target.querySelector('input:checked, button, select') || target;
      focusTarget.focus({ preventScroll: true });
    });
    document.addEventListener('shopify:section:unload', event => {
      if (!event.target.contains(bar)) return;
      window.removeEventListener('scroll', schedule);
      window.removeEventListener('resize', schedule);
      document.removeEventListener('change', schedule);
      cancelAnimationFrame(frame);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tog-theme-style"]) return;
  try {
    
(() => {
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const running = new Set();
  const selector = '[data-tog-reveal]';
  if (!('IntersectionObserver' in window) || !Element.prototype.animate) return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      if (preference.matches || !entry.target.isConnected) return;
      const siblings = entry.target.parentElement.querySelectorAll(':scope > [data-tog-reveal]');
      const index = Math.max(0, Array.from(siblings).indexOf(entry.target));
      const animation = entry.target.animate([
        { opacity: 0.65, transform: 'translateY(14px)' },
        { opacity: 1, transform: 'translateY(0)' }
      ], { duration: 580, delay: Math.min(index * 55, 165), easing: 'cubic-bezier(.22,1,.36,1)' });
      running.add(animation);
      animation.onfinish = animation.oncancel = () => running.delete(animation);
    });
  }, { threshold: 0.08 });
  function initialize(root) {
    root.querySelectorAll(selector).forEach(element => {
      if (seen.has(element)) return;
      seen.add(element);
      // Keep the initial viewport fully visible; animate only later discoveries.
      if (!preference.matches && element.getBoundingClientRect().top >= window.innerHeight) observer.observe(element);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(selector).forEach(element => observer.unobserve(element));
  });
  preference.addEventListener('change', () => {
    if (!preference.matches) return;
    observer.disconnect();
    running.forEach(animation => animation.cancel());
  });
})();

  } catch(e) { console.error(e); }
})();
})();
